import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22 20H6.8L23.4 3.4c.8-.8.8-2 0-2.8s-2-.8-2.8 0L4 17.2V2c0-1.2-.8-2-2-2S0 .8 0 2v20c0 .2 0 .6.2.8.2.4.6.8 1 1 .2.2.6.2.8.2h20c1.2 0 2-.8 2-2s-.8-2-2-2"
    }, null, -1)
  ]))]))
}
export default { render: render }